import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Action } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionService {
  private apiService = inject(ApiService);

  storeAction(data: Action) {
    return this.apiService.store(
      `action?name=${data.name}&actioncode=${data.actioncode}&description=${data.description}&type=${data.type}`,
      undefined
    );
  }

  getActions(): Observable<Action[]> {
    return this.apiService.getAll('action');
  }

  getAction(id: number): Observable<Action> {
    return this.apiService.getById('', id);
  }

  updateAction(data: Action, id: number) {
    const d = encodeURI(
      `action/${id}?name=${data.name}&actioncode=${data.actioncode}&description=${data.description}&type=${data.type}`
    );
    return this.apiService.update(d, undefined, id);
  }
}
